import { render, staticRenderFns } from "./PartnerSubscriptions.vue?vue&type=template&id=396e1bd1&scoped=true"
import script from "./PartnerSubscriptions.vue?vue&type=script&lang=js"
export * from "./PartnerSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e1bd1",
  null
  
)

export default component.exports